import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => ({
  container: {
    width: 225,
    height: 250,
    position: 'relative',
  },
  image: {
    position: 'absolute',
  }
}));
